import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mv-progress-bar" }
const _hoisted_2 = { class: "bar-area" }
const _hoisted_3 = { class: "pointer-row" }
const _hoisted_4 = { class: "limit-row" }
const _hoisted_5 = { class: "bar-pointer" }
const _hoisted_6 = { class: "bar-pointer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "current-pointer",
      style: _normalizeStyle(`width: ${_ctx.rate}%`)
    }, _toDisplayString(_ctx.data.current), 5),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "upper-bar",
        style: _normalizeStyle(`width: ${_ctx.rate}%`)
      }, null, 4),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "back-bar" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.data.start), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.data.end), 1)
      ])
    ])
  ]))
}